import React from 'react';
import { Dialog, DialogContent, IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';

interface IProps {
  /** Objekt-URL des Bildes; `null` hält den Dialog geschlossen. */
  objectUrl: string | null;
  onClose: () => void;
  alt?: string;
}

/**
 * Bild formatfüllend anzeigen. Gebraucht überall dort, wo ein Dokument ein Foto
 * ist — bei einem Ausweis entscheidet sich erst in der Vergrößerung, ob die
 * Aufnahme brauchbar ist.
 *
 * Der Aufrufer übergibt den Objekt-URL, den die Vorschau ohnehin schon erzeugt
 * hat. Ein zweites Laden entfällt damit, und die Grenze von Chromium für lange
 * Navigations-URLs bleibt außen vor (siehe `DocumentInlinePreview`).
 */
export const ImageZoomDialog: React.FC<IProps> = ({
  objectUrl,
  onClose,
  alt = 'Dokument',
}) => (
  <Dialog open={objectUrl !== null} onClose={onClose} maxWidth='lg'>
    <DialogContent sx={{ p: 0, position: 'relative' }}>
      <IconButton
        sx={{
          position: 'absolute',
          top: 8,
          right: 8,
          bgcolor: 'rgba(0,0,0,0.5)',
          color: 'common.white',
          '&:hover': { bgcolor: 'rgba(0,0,0,0.7)' },
        }}
        onClick={onClose}
      >
        <Close />
      </IconButton>
      {objectUrl !== null && (
        <img
          src={objectUrl}
          alt={alt}
          style={{ display: 'block', maxWidth: '100%', maxHeight: '85vh' }}
        />
      )}
    </DialogContent>
  </Dialog>
);
